import { Injectable, Type } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
    providedIn: 'root',
})
export class ModalService {
    // Constructor
    constructor(private readonly ngbModalService: NgbModal) {}

    /**
     * Abre un componente modal usando NgbModal y le pasa datos de entrada.
     * @param component La CLASE del componente que actuará como modal (Ej: MiModalComponent).
     * @param data Los datos que se quieren pasar al modal (que mapearán a propiedades del modal).
     * @param options Opciones de configuración de NgbModal (tamaño, backdrop, etc.).
     * @returns La referencia al modal de NgbModal.
     */
    open<T>(
        component: Type<T>,
        data?: Partial<T>,
        options: NgbModalOptions = { size: 'xl', centered: true }, // Opciones por defecto
    ) {
        // 1. Abre el modal usando el servicio nativo de NG-Bootstrap.
        const modalRef = this.ngbModalService.open(component, options);

        // 2. Transfiere los datos del parámetro 'data' a las propiedades del componente.
        // Esto simula el comportamiento de @Input()
        if (data) {
            // Copiamos los datos a la instancia del componente
            Object.assign(modalRef.componentInstance, data);
        }

        return modalRef;
    }

    /**
     * Cierra todos los modales abiertos.
     */
    dismissAll() {
        this.ngbModalService.dismissAll();
    }
}
